import Path from '@leverege/path'
import Evaluator from '../Evaluator.js'
import Comparision from './Comparision.js'
/**
 * Defines a satisfies class that can be tested, yielding either true, false, or null
 */
export default class PropertyEvaluator extends Evaluator {

  static TYPE = 'condition.Property'
  
  constructor( model, factory ) {
    super( model, factory )
    const { path, contextPath } = model
    const cp = contextPath ? contextPath.trim() : null
    const p = path ? path.trim() : null
    this.cPath = cp === null || cp.length === 0 ? null : Path( cp )
    this.path = p === null || p.length === 0 ? null : Path( p )
    this.pathStr = p
  }

  /**
   * By default, this will access path to get the value.
   * @param {Object} conxtext 
   * @returns the value to use in the comparison
   */
  getTargetValue( context ) {
    const obj = this.cPath == null ? context : this.cPath.get( context )
    if ( Array.isArray( obj ) && obj.length > 0 && obj[0].path != null ) {
      // Path/Value array. 
      for ( let n = 0; n < obj.length; n++ ) {
        if ( obj[n].path === this.pathStr ) {
          return obj[n].value
        }
      }
      return undefined
    }
    return this.path?.get( obj )
  }

  /**
    * Determines whether the target satisfies the model is met or not given the context
    * @param {*} context The context with which the satisfies method is to be executed
    * @return {boolean or null} depending on whether the data fields are known. Null means that it is
    * unclear if the target satisfies the condition
    */
  satisfies( context ) {
    let targetValue = this.getTargetValue( context )
    const { value1, value2, coerceValue, comparator : cmp } = this.model

    return Comparision.satisfies( targetValue, cmp, value1, value2, coerceValue )
  }
}
